<template>
    <div>
        <template v-if="width < 2054 && width > 1699">
            <vs-row justify="flex-end">
                <vs-col :key="index" v-for="(col, index) in 3" w="2"><br /></vs-col>
            </vs-row>
        </template>
        <vx-card title="입퇴원List">
        <div class="vx-row">
            <div class="vx-col w-full xl:w-1/1 mb-base text-center">
                <vs-button color="dark" type="line" icon-pack="feather" icon="icon-arrow-left" @click="updateDate(-1)"></vs-button>
                <span class="ml-5 mr-5"> {{ date }} ({{ day }}) </span>
                <date-picker
                    id="datepicker-component"
                    v-model="date"
                    @change="updateDate">
                </date-picker>
                <vs-button color="dark" type="line" icon-pack="feather" icon="icon-arrow-right" @click="updateDate(1)"></vs-button>
            </div>
        </div>
            <span id="statuscnt6Id">재원 : {{ status_cnt_6 + status_cnt_11 }} / 외래 : {{ remoteCount.COUNT3  }} </span>
            <div class="flex justify-end flex-wrap">
                <div v-for="(item, index) in doctor_cnt" :key="index" class="flex justify-end flex-wrap">
                    <span class="mr-1 mb-3">{{ item.MEDICAL_NM }}:({{ item.CNT }}) </span>
                </div>
            </div>
            <vs-button type="line" v-bind:class="activeMenu('1')" @click="tabClick('1')">입원예정 ({{ remoteCount.COUNT1
            }}명)</vs-button>
            <vs-button type="line" v-bind:class="activeMenu('3')" @click="tabClick('3')">외래 ({{ remoteCount.COUNT3
            }}명)</vs-button>
            <vs-button type="line" v-bind:class="activeMenu('2')" @click="tabClick('2')">퇴원예정 ({{ remoteCount.COUNT2
            }}명)</vs-button>
            <div class="flex justify-end flex-wrap mb-3"></div>
            <div class="tb_wrap">
                <div class="tb_box" id="remote" style="width:100%;overflow-x:auto;height:900px;">
                    <table style="width:100%;min-width:2000px;" class="border-collapse"
                        v-show="gubun_type == '1' && remoteList.length > 0">
                        <colgroup>
                            <!-- 첫번째 col요소에 w가 100이였는데 print icon추가시 크기 150으로 변경 2023-04-10 -->
                            <!-- 첫번째 col요소에 w가 150이였는데 상담의 추가시 크기 200으로 변경 2023-09-12 -->
                            <col width="200" />
                            <col width="80" />
                            <col width="100" />
                            <col width="190" />
                            <col width="120" />
                            <col width="100" />
                            <col width="150" />
                            <col width="100" />
                            <col width="100" />
                            <col width="100" />
                            <col width="100" />
                            <col width="100" />
                            <col width="100" />
                            <col width="150" />
                            <col width="100" />
                            <col width="100" />
                            <col width="200" />
                            <col width="200" />
                            <col width="200" />
                        </colgroup>
                        <thead>
                            <tr class="fixed_top">
                                <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header"></th>
                                <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header"
                                    @dblclick="orderList('NEW_RE')">구분</th>
                                <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header"
                                    @dblclick="orderList('MEDICAL_ROOM')">호실</th>
                                <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header"
                                    @dblclick="orderList('PATIENT_INFO')">이름 (나이, 성별) / 차트번호</th>
                                <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header"
                                    @dblclick="orderList('SICKNESS')">진단명</th>
                                <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header"
                                    @dblclick="orderList('IN_TIME')">입원예정시간</th>
                                <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header"
                                    @dblclick="orderList('CORONA')">선호병실</th>
                                <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header"
                                    @dblclick="orderList('MEAL_NAME')">입원일 식이</th>
                                <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header"
                                    @dblclick="orderList('MEAL_MEMO')">식이비고</th>
                                <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header"
                                    @dblclick="orderList('MEDICAL_MEMBER_NAME')">한방주치의</th>
                                <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header"
                                    @dblclick="orderList('WEST_MEDICAL_NAME')">양방주치의</th>
                                <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header"
                                    @dblclick="orderList('CONSULT_DOCTOR')">병동주치의</th>
                                <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header"
                                    @dblclick="orderList('MEDICAL_NAME')">본병원</th>

                                <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header"
                                    @dblclick="orderList('PROTECTOR')">주보호자</th>
                                <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header"
                                    @dblclick="orderList('PROTECTOR_PHONE')">주보호자 연락처</th>

                                <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header"
                                    @dblclick="orderList('CS_MEMBER_NM')">상담 담당자</th>
                                <template v-if="userLevel <= 5">
                                    <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header"
                                        @dblclick="orderList('CS_CONTENT')">상담메모</th>
                                </template>
                                <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header"
                                    @dblclick="orderList('PLAN')">치료플랜</th>

                                <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header"
                                    @dblclick="orderList('MEMO')">기타사항</th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-for="(item, index) in remoteList">
                                <tr :key="date + index" :class="item.NEW_RE == '신입' ? 'new' : 're'">
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">
                                        <!-- <vs-button color="success" size="samll" type="line" icon-pack="feather" icon="icon-search" @click="openChartPopup(item.PATIENT_UID)" /> -->
                                        <vs-button color="success" size="samll" type="line" icon-pack="feather"
                                            icon="icon-calendar" @click="openPatientCalendar(item.PATIENT_UID)" />
                                        <vs-button color="primary" size="samll" type="line" icon-pack="feather"
                                            icon="icon-edit-2" @click="openModifyPopup(item.PATIENT_UID)" />
                                        <vs-button color="primary" size="samll" type="line" icon-pack="feather"
                                            icon="icon-file" @click="print(item.PATIENT_UID)" />
                                    </td>
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.NEW_RE
                                    }}</td>
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{
                                        item.MEDICAL_ROOM }}</td>
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{
                                        item.PATIENT_INFO }} / {{ item.CHART_NO }}
                                        <span style="font-size: 12px; color: red;">{{ item.IN_LONG_TERM === 'Y' ? '장기미내원환자' : '' }}</span>    
                                    </td>
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{
                                        item.SICKNESS }}</td>
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{
                                        item.IN_TIME }}</td>
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">
                                        1순위 : {{ item.WANTED_ROOM1.length > 0 ? item.WANTED_ROOM1.substring(1) + '인실': '미정'}}<br />
                                        2순위 : {{ item.WANTED_ROOM2.length > 0 ? item.WANTED_ROOM2.substring(1) + '인실': '미정' }}<br />
                                        3순위 : {{ item.WANTED_ROOM3.length > 0 ? item.WANTED_ROOM3.substring(1) + '인실': '미정' }}
                                    </td>
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{
                                        item.MEAL_NAME }}</td>
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{
                                        item.MEAL_MEMO }}</td>
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{
                                        item.MEDICAL_MEMBER_NAME }}</td>
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{
                                        item.WEST_MEDICAL_NAME }}</td>
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{
                                        item.CONSULT_DOCTOR }}</td>
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{
                                        item.MEDICAL_NAME }}</td>

                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{
                                        item.PROTECTOR }}</td>
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{
                                        item.PROTECTOR_PHONE }}</td>

                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{
                                        item.MAIN_CS_UID }}</td>
                                    <template v-if="userLevel <= 5">
                                        <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{
                                            item.CS_CONTENT }}</td>
                                    </template>
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.PLAN
                                    }}</td>

                                    <td class="p-2 border border-solid d-theme-border-grey-light">{{ item.MEMO }}</td>
                                </tr>
                            </template>
                        </tbody>
                    </table>
                    <table style="width:100%;min-width:2000px;" class="border-collapse"
                        v-show="gubun_type == '2' && remoteList.length > 0">
                        <colgroup>
                            <!-- 첫번째 col요소에 w가 100이였는데 print icon추가시 크기 150으로 변경 2023-04-10 -->
                            <!-- 첫번째 col요소에 w가 150이였는데 상담의 추가시 크기 200으로 변경 2023-09-12 -->
                            <col width="200" />
                            <col width="190" />
                            <col width="160" />
                            <col width="100" />
                            <col width="100" />
                            <col width="100" />
                            <col width="120" />
                            <col width="120" />
                            <col width="160" />
                            <col width="160" />
                            <col width="100" />
                            <col width="160" />
                            <col width="*" />
                        </colgroup>
                        <thead>
                            <tr class="fixed_top">
                                <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header"></th>
                                <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header"
                                    @dblclick="orderList('PATIENT_INFO')">이름 (나이, 성별 / 차트번호)</th>
                                <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header"
                                    @dblclick="orderList('MEDICAL_ROOM')">호실</th>
                                <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header"
                                    @dblclick="orderList('MEDICAL_MEMBER_NAME')">한방주치의</th>
                                <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header"
                                    @dblclick="orderList('WEST_MEDICAL_NAME')">양방주치의</th>
                                <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header"
                                    @dblclick="orderList('CONSULT_DOCTOR')">병동주치의</th>
                                <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header"
                                    @dblclick="orderList('IN_DATE')">재입예정일</th>
                                <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header"
                                    @dblclick="orderList('OUT_TIME')">퇴원예정시간</th>
                                <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header"
                                    @dblclick="orderList('MEAL_NAME')">퇴원일 식이</th>
                                <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header"
                                    @dblclick="orderList('PATIENT_PHONE')">연락처</th>
                                <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header"
                                    @dblclick="orderList('PROTECTOR')">주보호자</th>
                                <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header"
                                    @dblclick="orderList('PROTECTOR_PHONE')">주보호자 연락처</th>
                                <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header"
                                    @dblclick="orderList('MEMO')">기타사항</th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-for="(item, index) in remoteList">
                                <tr :key="date + index" class="colored">
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">
                                        <vs-button color="success" size="samll" type="line" icon-pack="feather"
                                            icon="icon-calendar" @click="openPatientCalendar(item.PATIENT_UID)" />
                                        <vs-button color="primary" size="samll" type="line" icon-pack="feather"
                                            icon="icon-edit-2" @click="openModifyPopup(item.PATIENT_UID)" />
                                        <vs-button color="primary" size="samll" type="line" icon-pack="feather"
                                            icon="icon-file" @click="print(item.PATIENT_UID)" />
                                    </td>
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{
                                        item.PATIENT_INFO }} / {{ item.CHART_NO }}
                                        <span style="font-size: 12px; color: red;">{{ item.IN_LONG_TERM === 'Y' ? '장기미내원환자' : '' }}</span>
                                    </td>
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{
                                        item.MEDICAL_ROOM }}</td>
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{
                                        item.MEDICAL_MEMBER_NAME }}</td>
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{
                                        item.WEST_MEDICAL_NAME }}</td>
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{
                                        item.CONSULT_DOCTOR }}</td>
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{
                                        item.IN_DATE }}</td>
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{
                                        item.OUT_TIME }}</td>
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{
                                        item.MEAL_NAME }}</td>
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{
                                        item.PATIENT_PHONE }}</td>
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{
                                        item.PROTECTOR }}</td>
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{
                                        item.PROTECTOR_PHONE }}</td>
                                    <td class="p-2 border border-solid d-theme-border-grey-light">{{ item.MEMO }}</td>
                                </tr>
                            </template>
                        </tbody>
                    </table>
                    <table style="width:100%;min-width:2000px;" class="border-collapse"
                        v-show="gubun_type == '3' && remoteList.length > 0">
                        <colgroup>
                            <!-- 첫번째 col요소에 w가 100이였는데 print icon추가시 크기 150으로 변경 2023-04-10 -->
                            <!-- 첫번째 col요소에 w가 150이였는데 상담의 추가시 크기 200으로 변경 2023-09-12 -->
                            <col width="200" />
                            <col width="190" />
                            <col width="160" />
                            <col width="100" />
                            <col width="100" />
                            <col width="100" />
                            <col width="120" />
                            <col width="120" />
                            <col width="160" />
                            <col width="160" />
                            <col width="100" />
                            <col width="160" />
                            <col width="*" />
                        </colgroup>
                        <thead>
                            <tr class="fixed_top">
                                <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header"></th>
                                <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header"
                                    @dblclick="orderList('PATIENT_INFO')">이름 (나이, 성별 / 차트번호)</th>
                                <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header"
                                    @dblclick="orderList('MEDICAL_ROOM')">호실</th>
                                <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header"
                                    @dblclick="orderList('MEDICAL_MEMBER_NAME')">한방주치의</th>
                                <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header"
                                    @dblclick="orderList('WEST_MEDICAL_NAME')">양방주치의</th>
                                <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header"
                                    @dblclick="orderList('CONSULT_DOCTOR')">병동주치의</th>
                                <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header"
                                    @dblclick="orderList('IN_DATE')">재입예정일</th>
                                <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header"
                                    @dblclick="orderList('OUT_TIME')">퇴원예정시간</th>
                                <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header"
                                    @dblclick="orderList('MEAL_NAME')">퇴원일 식이</th>
                                <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header"
                                    @dblclick="orderList('PATIENT_PHONE')">연락처</th>
                                <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header"
                                    @dblclick="orderList('PROTECTOR')">주보호자</th>
                                <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header"
                                    @dblclick="orderList('PROTECTOR_PHONE')">주보호자 연락처</th>
                                <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header"
                                    @dblclick="orderList('MEMO')">기타사항</th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-for="(item, index) in remoteList">
                                <tr :key="date + index" class="colored">
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">
                                        <vs-button color="success" size="samll" type="line" icon-pack="feather"
                                            icon="icon-calendar" @click="openPatientCalendar(item.PATIENT_UID)" />
                                        <vs-button color="primary" size="samll" type="line" icon-pack="feather"
                                            icon="icon-edit-2" @click="openModifyPopup(item.PATIENT_UID)" />
                                        <vs-button color="primary" size="samll" type="line" icon-pack="feather"
                                            icon="icon-file" @click="print(item.PATIENT_UID)" />
                                    </td>
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{
                                        item.PATIENT_INFO }} / {{ item.CHART_NO }}
                                        <br>
                                    <span style="font-size: 12px; color: red;">{{ item.IN_LONG_TERM === 'Y' ? '장기미내원환자' : '' }}</span>    
                                    </td>
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{
                                        item.MEDICAL_ROOM }}</td>
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{
                                        item.MEDICAL_MEMBER_NAME }}</td>
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{
                                        item.WEST_MEDICAL_NAME }}</td>
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{
                                        item.CONSULT_DOCTOR }}</td>
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{
                                        item.IN_DATE }}</td>
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{
                                        item.OUT_TIME }}</td>
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{
                                        item.MEAL_NAME }}</td>
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{
                                        item.PATIENT_PHONE }}</td>
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{
                                        item.PROTECTOR }}</td>
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{
                                        item.PROTECTOR_PHONE }}</td>
                                    <td class="p-2 border border-solid d-theme-border-grey-light">{{ item.MEMO }}</td>
                                </tr>
                            </template>
                        </tbody>
                    </table>
                    <div class="text-center no_list" v-show="remoteList.length == 0">
                        등록된 환자가 없습니다
                    </div>
                </div>
            </div>
        </vx-card>
        <!-- 차트보기 팝업 시작 -->
        <vs-popup title="차트보기" :active.sync="chartPopup">
            <div class="vx-row">
                <div class="vx-col w-full lg:w-1/1 mb-base">
                    <vx-card class="p-2">
                        <div class="text-center">
                            <p class="text-grey">#{{ chartData.chart_no }}</p>
                            <h4>{{ chartData.patientUsername }}({{ chartData.status_name }})</h4>
                            <p class="text-grey">{{ chartData.patientAge }}, {{ chartData.patientGender }}</p>
                            <p class="text-grey">{{ chartData.patient_phone }}</p>
                        </div>
                        <vs-divider></vs-divider>
                        <div class="flex justify-between text-center">
                            <span>
                                <p class="font-semibold">{{ chartData.medicalRoomNm }}({{ chartData.medicalRoomNumberNm }})
                                </p>
                                <small class="text-grey">병동(호실)</small>
                            </span>
                            <span>
                                <p class="font-semibold">{{ chartData.medicalName }}</p>
                                <small class="text-grey">본 병원</small>
                            </span>
                            <span>
                                <p class="font-semibold">{{ chartData.sickNess }}</p>
                                <small class="text-grey">병명</small>
                            </span>
                        </div>
                        <vs-divider></vs-divider>
                        <div class="my-6">
                            <h5 class="mb-2">치료플랜</h5>
                            <p class="plan_text">
                                <template v-if="chartData.plan == null || chartData.plan == 0">작성한 치료플랜 없음</template>
                                <template v-else>{{ chartData.plan }}</template>
                            </p>
                        </div>
                        <vs-divider></vs-divider>
                        <table style="width:100%;" class="border-collapse calendar">
                            <colgroup>
                                <col width="40%" />
                                <col width="60%" />
                            </colgroup>

                            <tbody>
                                <tr>
                                    <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">
                                        최초입원일</th>
                                    <td class="p-2 border border-solid d-theme-border-grey-light">{{ chartData.in_init_date
                                    }}</td>
                                </tr>
                                <tr>
                                    <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">
                                        입원일</th>
                                    <td class="p-2 border border-solid d-theme-border-grey-light">{{ chartData.in_date }}
                                    </td>
                                </tr>
                                <tr>
                                    <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">
                                        퇴원예정일</th>
                                    <td class="p-2 border border-solid d-theme-border-grey-light">{{ chartData.out_date }}
                                    </td>
                                </tr>
                                <tr>
                                    <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">
                                        왼퇴여부</th>
                                    <td class="p-2 border border-solid d-theme-border-grey-light">{{ chartData.complate_yn
                                    }}</td>
                                </tr>
                                <tr>
                                    <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">
                                        식이</th>
                                    <td class="p-2 border border-solid d-theme-border-grey-light">{{ chartData.meal_name }}
                                    </td>
                                </tr>
                                <tr>
                                    <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">
                                        보호자</th>
                                    <td class="p-2 border border-solid d-theme-border-grey-light">{{
                                        chartData.protector_phone }}</td>
                                </tr>
                                <tr>
                                    <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">
                                        한방주치의</th>
                                    <td class="p-2 border border-solid d-theme-border-grey-light">{{ chartData.medical_nm }}
                                    </td>
                                </tr>
                                <tr>
                                    <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">
                                        양방주치의</th>
                                    <td class="p-2 border border-solid d-theme-border-grey-light">{{
                                        chartData.west_medical_nm }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </vx-card>
                </div>
            </div>
        </vs-popup>
        <myPrint id="myPrintId" ref="myPrint" style="display: none;" />
    </div>
</template>

<script>
import axiosClass from '@/../util/axiosClass';
import dateClass from '@/../util/dateClass';
import DatePicker from 'vue2-datepicker';
import '../../assets/scss/vuexy/extraComponents/_datePicker.scss'
// import 'vue2-datepicker/index.css';
import store from '@/store/store';
import { EventBus } from '../../../util/vue-event-bus';
import myPrint from "../printComponent/myPrint.vue";
export default {
    components: {
        DatePicker,
        myPrint,
    },
    data() {
        return {
            status_cnt_6: 0, // 재원값 데이터 추가
            doctor_cnt: [], // 원장 스케줄 카운트 추가
            now_date: dateClass.dateYYYYMMDD(),
            date: dateClass.dateYYYYMMDD(),
            day: dateClass.getDay(),
            gubun_type: '1',
            remoteCount: {},
            lists: [],
            patientUid: '',
            remoteList: [],
            chartPopup: false,
            chartData: {},
            modifyPopup: false,
            orderCategory: '',
            orderType: 'ASC',
            width: window.innerWidth,
            userLevel: "",
            status_cnt_11: 0,
            status_cnt_8: 0,
        };
    },
    methods: {
        async print(uid) {
            try {
                const myPrint = document.getElementById("myPrintId");
                myPrint.style.display = "block";  // 출력할 컴포넌트 보이기

                // printComponent() 메서드 실행
                await this.$refs.myPrint.printComponent(uid);

                myPrint.style.display = "none";  // 출력할 컴포넌트 숨기기
            } catch (error) {
                console.error(error);
            }
        },
        handleResize(event) {
            this.width = window.innerWidth;
        },
        async init() {
            this.userLevel = store.getters.getCDLEVEL;
            await this.list();
        },
        async list() {
            this.remoteList = [];

            this.$vs.loading({
                type: 'default',
                container: '#remote',
                background: 'rgba(0,0,0,0.1)',
                color: 'primary',
                scale: 1.5,
            });

            const { data } = await axiosClass.get(`/api/remote/list2/${this.date}/${this.gubun_type}`, {}, true);
            
            this.remoteCount = data.counts;
            this.remoteList = data.lists.map(arr => {
                return arr.DATA;
            });

            setTimeout(() => {
                this.$vs.loading.close('#remote > .con-vs-loading');
            }, 100);
        },
        // async updateDate(day) {
        //     if (day == -1) {
        //         this.date = dateClass.prevYYYYMMDD2(this.date);
        //     } else if (day == 1) {
        //         this.date = dateClass.nextYYYYMMDD2(this.date);
        //     }
        //     // this.day = dateClass.getDay(this.date);
        //     this.now_date = this.now_date; // 캘린더 날짜 선택시 날짜 동기화
        //     await this.init();
        // },
        async updateDate(day) {
            if (day === -1) {
                this.date = dateClass.prevYYYYMMDD2(this.date);
            } else if (day === 1) {
                this.date = dateClass.nextYYYYMMDD2(this.date);
            } else if (day === undefined) {
                this.date = this.now_date;
            }
            this.day = dateClass.getDay(this.date);

            this.date = dateClass.dateYYYYMMDD3(this.date);
            await this.init();
        },
        async tabClick(tab) {
            this.gubun_type = tab;
            await this.init();
        },
        activeMenu(gubun_type) {
            if (gubun_type == this.gubun_type) {
                return 'activeMenu';
            } else {
                return '';
            }
        },

        // 2023-05-19 추가 /--------
        async getState() { // 재원값 추가

            const { data } = await axiosClass.get('/api/ward/status', {}, true);
            this.status_cnt_6 = data.status_cnt_6;
            this.status_cnt_11 = data.status_cnt_11;
        },

        async getSchedulecnt() {
            // 2023-05-19 api데이터 및 원장 스케줄 카운트 추가
            const { data } = await axiosClass.get('/api/doctor/list/' + this.now_date, {}, true); // 원장 스케줄 카운트 데이터 추가
            this.doctor_cnt = data.doctor_cnt;
        },
        // -------------------/

        // async openChartPopup(uid) {
        //     const { data } = await axiosClass.get('/api/remote/userData/' + uid, {}, true);

        //     this.chartData.patientUsername = data.patientData.PATIENT_USERNAME;
        //     this.chartData.patientAge = data.patientData.PATIENT_AGE;
        //     this.chartData.patientGender = data.patientData.PATIENT_GENDER_CONVERT;
        //     this.chartData.medicalRoomNm = data.patientData.MEDICAL_ROOM_NM; 
        //     this.chartData.medicalRoomNumberNm = data.patientData.MEDICAL_ROOM_NUMBER_NM;
        //     this.chartData.medicalName = data.patientData.MEDICAL_NAME;
        //     this.chartData.sickNess = data.patientData.SICKNESS;
        //     this.chartData.plan = data.patientData.PLAN;
        //     this.chartData.memo = data.patientData.MEMO;
        //     this.chartData.chart_no = data.patientData.CHART_NO;
        //     this.chartData.status_name = data.patientData.STATUS_NAME;
        //     this.chartData.patient_phone = data.patientData.PATIENT_PHONE;
        //     this.chartData.in_init_date = data.patientData.IN_INIT_DATE;
        //     this.chartData.in_date = data.patientData.IN_DATE;
        //     this.chartData.out_date = data.patientData.OUT_DATE;
        //     this.chartData.complate_yn = data.patientData.COMPLATE_YN;
        //     this.chartData.meal_name = data.patientData.MEAL_NAME;
        //     this.chartData.medical_nm = data.patientData.MEDICAL_NM;
        //     this.chartData.west_medical_nm = data.patientData.WEST_MEDICAL_NAME;
        //     this.chartData.protector_phone = data.patientData.PROTECTOR_PHONE;

        //     this.chartPopup = true;
        // },

        async openModifyPopup(uid) {
            this.$EventBus.$emit('memberView', uid);
        },

        orderList(category) {
            if (this.orderCategory != category) {
                this.orderCategory = category;
                this.orderType = 'ASC';
            } else {
                if (this.orderType == 'ASC') {
                    this.orderType = 'DESC';
                } else if (this.orderType == 'DESC') {
                    this.orderType = 'ASC';
                }
            }

            this.remoteList.sort((a, b) => {
                if (this.orderType == 'ASC') {
                    return a[category] < b[category] ? -1 : a[category] > b[category] ? 1 : 0;
                } else if (this.orderType == 'DESC') {
                    return a[category] < b[category] ? 1 : a[category] > b[category] ? -1 : 0;
                }
            });
        },
        openPatientCalendar(patientUid) {
            this.$router.push({ name: 'scheduleCalendar', params: { uid: patientUid } });
        }
    },
    async mounted() {
        window.addEventListener('resize', this.handleResize);
        await this.init();
        EventBus.$on('remoteListRefresh', async () => {
            await this.init('');
        });
        EventBus.$on('remoteListCsRefresh', async () => {
            await this.init('');
        });
        await this.getState('');
        await this.getSchedulecnt('');
    },
    created() {
        this.date = dateClass.dateYYYYMMDD3();
        this.day = dateClass.getDay(this.date);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
};
</script>

<style>
.reservation_div {
    vertical-align: top;
}

.reservation_div table {
    border: 0px;
    border-spacing: 0px;
    border-collapse: separate;
}

.reservation_div table tr td:nth-child(odd) {
    background-color: #c9c9c9;
    text-align: center;
    padding: 10px;
    border: 1px solid #4d4d4d;
}

.reservation_div table tr td:nth-child(even) {
    text-align: center;
    padding: 10px;
}

.reservation_div table tr td {
    border: 1px solid #4d4d4d;
}

.header_bg {
    background-color: #e2efdb !important;
    font-size: 12px !important;
}

.th_bg {
    background-color: #d9e2f3 !important;
}

.new_bg {
    background-color: #ffd7d2 !important;
    font-size: 12px !important;
}

.re_bg {
    background-color: #b2ebe9 !important;
    font-size: 12px !important;
}

.tb_box {
    height: 500px;
    overflow: auto;
}

.table_header {
    position: sticky;
    top: 0 !important;
    z-index: 100;
    /* border: 3px solid red; */
}

.selectOn {
    border: 3px solid #439798;
    color: #fff;
}

.selectOff {
    border: 0px;
    color: #fff;
}

.includeIcon {
    display: initial;
}

.mx-datepicker-popup {
    z-index: 90000000 !important;
}


.activeMenu {
    border-color: #015666;
}

/* 20210528 홍현표 추가 */
.activeMenu2 {
    border-bottom-width: 3px !important;
    border-color: #015666;
}

/* 20210528 홍현표 추가 */
.tb_box {
    height: 630px;
    overflow: auto;
}

input::placeholder {
    color: rgb(185, 185, 185);
}

.hs-2 {
    height: 75px;
    text-align: left !important;
}

.hs-3 {
    height: 111px;
    text-align: left !important;
}

.no_list {
    font-size: 18px;
}

.new>td {
    background-color: rgb(220, 233, 213);
}

.re>td {
    background-color: rgb(253, 242, 208);
}

#statuscnt6Id {
    display: flex;
    justify-content: flex-end;
    font-size: 20px;
}

.mx-datepicker {
    width: 10px;
}
#datepicker-component.mx-datepicker svg {
    color: green;
    margin-top: 3px;
}
#datepicker-component input {
    border: 0;
    outline: none;
    box-shadow: none;
}
</style>
